/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const defaultLineChartData = {
    labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    datasets: [
        {
            label: 'Fax Cargo',
            color: 'info',
            data: [30, 90, 40, 140, 290, 290, 340, 230, 400, 140, 290, 290],
        },
        {
            label: 'Fax Ocean',
            color: 'dark',
            data: [40, 80, 70, 90, 30, 90, 140, 130, 200, 90, 30, 90],
        },
        {
            label: 'Shipment: Forwarding Agent',
            color: 'primary',
            data: [50, 40, 300, 220, 500, 250, 400, 230, 350, 500, 250, 400],
        },
    ],
};

export default defaultLineChartData;
